import axios from 'axios';
import * as constants from '../../constants/CONSTANT';

export function getCrmAuthHeaders() {
  const raw = localStorage.getItem('token');
  if (!raw || raw === 'null' || raw === 'undefined') return {};
  return { Authorization: raw };
}

export async function fetchRecordViewConfigRows(roleId) {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/permissions/role/${roleId}/recordview-config`,
    { headers: getCrmAuthHeaders() }
  );
  return res.data?.success ? res.data.data || [] : [];
}

export async function fetchObjectMetaBatch(objectNames) {
  const headers = getCrmAuthHeaders();
  const results = await Promise.all(
    objectNames.map(async (on) => {
      try {
        const [rvRes, layRes] = await Promise.all([
          axios.get(
            `${constants.API_BASE_URL}/api/recordview/object/${encodeURIComponent(on)}`,
            { headers }
          ),
          axios.get(
            `${constants.API_BASE_URL}/api/objectconfig/layouts/${encodeURIComponent(on)}`,
            { headers }
          ),
        ]);
        return {
          on,
          recordviews: rvRes.data?.success ? rvRes.data.data || [] : [],
          layouts: layRes.data?.success ? layRes.data.data || [] : [],
          error: null,
        };
      } catch (e) {
        return {
          on,
          recordviews: [],
          layouts: [],
          error: e.response?.data?.message || e.message || 'Failed to load',
        };
      }
    })
  );
  const map = {};
  for (const r of results) {
    map[r.on] = { recordviews: r.recordviews, layouts: r.layouts, error: r.error };
  }
  return map;
}

export function configRowsToMapByObject(configRows) {
  const m = {};
  for (const row of configRows || []) {
    if (row?.object_name) m[row.object_name] = row;
  }
  return m;
}

/** Build display strings for one object using saved config + metadata. */
export function formatRecordViewLayoutCells(cfg, meta) {
  const safeCfg = cfg || {
    recordview_ids: [],
    default_detail_layout_id: null,
    default_edit_layout_id: null,
  };
  const recordviews = meta?.recordviews || [];
  const layouts = meta?.layouts || [];
  const rvLabels = (safeCfg.recordview_ids || [])
    .map((id) => {
      const r = recordviews.find((x) => String(x.id) === String(id));
      return r ? r.view_label || r.name || id : id;
    })
    .filter(Boolean);
  const detailLay = layouts.find(
    (l) =>
      String(l.layout_type || '').toUpperCase() === 'DETAIL' &&
      String(l.layout_id) === String(safeCfg.default_detail_layout_id)
  );
  const editLay =
    layouts.find(
      (l) =>
        String(l.layout_type || '').toUpperCase() === 'EDIT' &&
        String(l.layout_id) === String(safeCfg.default_edit_layout_id)
    ) ||
    (String(safeCfg.default_edit_layout_id) === String(safeCfg.default_detail_layout_id)
      ? detailLay
      : layouts.find(
          (l) =>
            String(l.layout_type || '').toUpperCase() === 'DETAIL' &&
            String(l.layout_id) === String(safeCfg.default_edit_layout_id)
        ));
  return {
    recordViews: rvLabels.length ? rvLabels.join(', ') : '—',
    detailLayout: detailLay
      ? detailLay.layout_name || String(safeCfg.default_detail_layout_id || '')
      : safeCfg.default_detail_layout_id
        ? String(safeCfg.default_detail_layout_id)
        : '—',
    editLayout: editLay
      ? editLay.layout_name || String(safeCfg.default_edit_layout_id || '')
      : safeCfg.default_edit_layout_id
        ? String(safeCfg.default_edit_layout_id)
        : '—',
  };
}
